import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const required = route.data?.['role'] as string | undefined;
  if (!required) return true;

  // Revalida o papel AO VIVO no backend (revogacao de admin imediata),
  // em vez de confiar so na claim do JWT (que dura ~4h).
  return auth.refreshRole().pipe(
    map(() => {
      if (auth.isAdmin()) return true;
      if (required === 'ADMIN') return router.createUrlTree(['/conferencia']);
      return true;
    }),
  );
};
